import { mapForm } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { RealTimeForm } from './RealTimeForm'
import { ScriptForm } from './ScriptForm'

export const Form: FC<ReturnType<typeof mapForm>> = ({
  description,
  headline,
  script,
  realTimeFormScript,
  tracking_enabled,
  action_on_submit,
  submit_page_message,
  submit_redirect_url,
}) => {
  if (realTimeFormScript) {
    return (
      <RealTimeForm
        action_on_submit={action_on_submit}
        description={description}
        headline={headline}
        realTimeFormScript={realTimeFormScript}
        submit_page_message={submit_page_message}
        submit_redirect_url={submit_redirect_url}
        tracking_enabled={tracking_enabled}
      />
    )
  } else if (script) {
    return (
      <ScriptForm
        action_on_submit={action_on_submit}
        description={description}
        headline={headline}
        script={script}
        submit_page_message={submit_page_message}
        submit_redirect_url={submit_redirect_url}
        tracking_enabled={tracking_enabled}
      />
    )
  }
}
